import React, { PropsWithChildren } from 'react';

import { ReactComponent as IconInfo } from '@skippay/core/assets/icons/info.svg';
import { ReactComponent as IconWarning } from '@skippay/core/assets/icons/warning.svg';
import { mergeClasses } from '@skippay/core/utils/classUtils';

interface Props {
	className?: string;
	variant?: 'info' | 'warning';
}

function Icon({ variant }: { variant: Props['variant'] }) {
	switch (variant) {
		case 'info':
			return <IconInfo className="h-7 min-h-7 w-7 min-w-7 text-blue-500 dark:text-white" />;
		case 'warning':
			return <IconWarning className="h-7 min-h-7 w-7 min-w-7 text-orange-500" />;
		default:
			return <IconInfo className="h-7 min-h-7 w-7 min-w-7 text-blue-500 dark:text-white" />;
	}
}

export function InfoBox(props: PropsWithChildren<Props>): JSX.Element {
	return (
		<div
			className={mergeClasses(
				'flex flex-row items-center gap-3 rounded-lg px-4! py-2!',
				{
					'dark:bg-d-blue-100 bg-blue-100': props.variant === 'info' || !props.variant,
					'bg-orange-50 dark:bg-orange-500/40': props.variant === 'warning',
				},
				props.className
			)}
		>
			<Icon variant={props.variant} />
			<div
				className={mergeClasses('flex flex-col justify-center gap-2 text-gray-900 dark:text-white')}
			>
				{props.children}
			</div>
		</div>
	);
}
